import React, { useState, Dispatch, SetStateAction, FC } from 'react'
import styles from './AboutArtist.module.scss'
import AboutArtist from './AboutArtist'
import InsideTheStudio from '../insideTheStudio'
import { useSelector } from 'react-redux'
import {
  getAboutArtist,
  getInsideTheStudioImages,
  getIsUsersArtworksAccount,
} from '../../selectors'
import { hasAnyValue } from '../../helpers'
import classNames from 'classnames'
import AboutArtistHeader from './AboutArtistHeader'
type Props = {
  setFollowedUserArray: Dispatch<SetStateAction<ReadonlyArray<number>>>
  followedUserArray: ReadonlyArray<number>
}
const AboutSection: FC<Props> = ({ followedUserArray, setFollowedUserArray }: Props) => {
  const [showUploader, setShowUploader] = useState(false)
  const aboutArtist = useSelector(getAboutArtist)
  const images = useSelector(getInsideTheStudioImages)
  const myOwnAccount = useSelector(getIsUsersArtworksAccount)
  if (!images.length && !hasAnyValue(aboutArtist) && !myOwnAccount) {
    return null
  }
  return (
    <div className={styles.wrapper}>
      <div
        className={classNames(
          {
            [styles.aboutSectionCentered]: !images.length,
          },
          styles.aboutSection
        )}
        id='about-section'
      >
        <AboutArtistHeader
          followedUserArray={followedUserArray}
          setFollowedUserArray={setFollowedUserArray}
        />
        <InsideTheStudio showUploader={showUploader} setShowUploader={setShowUploader} />
        <AboutArtist
          showUploader={showUploader}
          followedUserArray={followedUserArray}
          setFollowedUserArray={setFollowedUserArray}
        />
      </div>
    </div>
  )
}

export default AboutSection
